module.exports = __webpack_public_path__ + "img/fwdbuttonPressed.5569f350.png";